import { render, staticRenderFns } from "./ProcessInsPoint.vue?vue&type=template&id=c2509f82&scoped=true"
import script from "./ProcessInsPoint.vue?vue&type=script&lang=js"
export * from "./ProcessInsPoint.vue?vue&type=script&lang=js"
import style0 from "./ProcessInsPoint.vue?vue&type=style&index=0&id=c2509f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2509f82",
  null
  
)

export default component.exports